/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Combo_Recipe_Type_UnitInputs */

const vi_combo_recipe_type_unit = /** @type {(inputs: Combo_Recipe_Type_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn vị`)
};

/**

* @param {Combo_Recipe_Type_UnitInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const combo_recipe_type_unit = /** @type {((inputs?: Combo_Recipe_Type_UnitInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Combo_Recipe_Type_UnitInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_combo_recipe_type_unit(inputs)
});